import { useEffect, useRef } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import FieldTextAreaAutoSize from '../fields/fieldTextAreaAutoSize';
import { LabelAnswer } from './labelAnswer';
import { Box } from '@mui/material';

type Props = {
    title?: string;
    placeholder?: string;
    required: false | boolean;
    onChange: (value: any) => void;
    idQuestion?: string;
    questionType?: string;
    type?: 'text' | 'big-text';
    subtype?: 'number' | 'alphabet' | 'alphanumeric';
    value?: string;
    disabled?: boolean;
    dominantColor?: string;
    icon?: JSX.Element | string | undefined;
};

const FieldTextAnswer = ({
    title,
    placeholder,
    required,
    onChange,
    idQuestion,
    questionType,
    type = 'text',
    subtype,
    value,
    disabled,
    dominantColor,
    icon,
}: Props) => {
    const formik = useFormik({
        initialValues: {
            idQuestion,
            answer: value || '',
            type: questionType,
            why: '',
        },
        validationSchema: Yup.object({
            answer: (() => {
                let schema = Yup.string();
                if (required) {
                    schema = schema.required('La respuesta es obligatoria');
                }
                switch (subtype) {
                    case 'number':
                        schema = schema.matches(
                            /^\d+$/,
                            'Debe ser un valor numérico'
                        );
                        break;
                    case 'alphabet':
                        schema = schema.matches(
                            /^[A-Za-zÁÉÍÓÚáéíóúñÑ\s]+$/,
                            'Solo se permiten letras'
                        );
                        break;
                    case 'alphanumeric':
                        schema = schema.matches(
                            /^[A-Za-z0-9ÁÉÍÓÚáéíóúñÑ!@#$%^&*()_+\-=;:,.<>?/\"' ]+$/,
                            'Solo se permiten letras, números, espacios y los siguientes caracteres especiales: ! @ # $ % ^ & * ( ) _ + - = ; : , . < > ? / " \''
                        );
                        break;
                }
                return schema;
            })(),
        }),
        onSubmit: (form) => {
            console.log(form);
        },
    });

    const prevExternalValueRef = useRef(value);

    useEffect(() => {
        if (value === prevExternalValueRef.current) {
            return;
        }
        prevExternalValueRef.current = value;
        if (value === undefined || value === null) {
            return;
        }
        const next = String(value);
        if (next !== formik.values.answer) {
            void formik.setFieldValue('answer', next, false);
        }
    }, [value]);

    useEffect(() => {
        const answer = formik.values.answer;
        onChange({
            ...formik.values,
            answer,
            error:
                (required && !answer.trim()) ||
                (answer === formik.values.answer &&
                    Boolean(formik.errors.answer)),
        });
    }, [formik.values, formik.errors.answer, required]);

    return (
        <>
            <LabelAnswer
                text={title}
                isRequired={required}
                dominantColor={dominantColor}
            />
            <br />
            <FieldTextAreaAutoSize
                name="answer"
                touched={Boolean(formik.errors.answer)}
                errors={formik.errors.answer}
                placeholder={placeholder}
                required={required}
                onChange={formik.handleChange}
                type={type}
                value={formik.values.answer}
                disabled={disabled}
                dominantColor={dominantColor}
                icon={icon}
            />
        </>
    );
};

export default FieldTextAnswer;
